import { render, staticRenderFns } from "./pwaprompt.vue?vue&type=template&id=29ca56eb&scoped=true"
import script from "./pwaprompt.vue?vue&type=script&lang=js"
export * from "./pwaprompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ca56eb",
  null
  
)

export default component.exports